import React from "react";
import { ErrorBoundary } from "react-error-boundary";

import { BrandPageImageErrorFallback } from "./BrandPageImageErrorFallback";

export const MaybeBrandPageImageErrorBoundaryWrapper = ({
  enabled,
  children,
}: {
  enabled: boolean;
  children: React.ReactNode;
}) => {
  if (!enabled) {
    return <>{children}</>;
  }

  return (
    <ErrorBoundary FallbackComponent={BrandPageImageErrorFallback}>
      {children}
    </ErrorBoundary>
  );
};
